import { AuthData, useAuth } from "common/auth/Auth";
import { urls } from "common/urls";
import React, { ReactNode } from "react";
import { Navigate, useLocation, RouteProps } from "react-router-dom";
import { LoadingLayout } from "./layouts/LoadingLayout";
import { Loading } from "./Loading";

type ProtectedRouteProps = RouteProps & {
  authz(auth: AuthData): boolean;
  element: ReactNode; // This replaces the children/render approach
};

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  authz = () => true,
  element: Component,
  ...rest
}) => {
  const auth: AuthData = useAuth();
  const location = useLocation();

  if (auth.loading) {
    return (
      <LoadingLayout>
        <Loading />
      </LoadingLayout>
    );
  }

  if (auth.isLoggedIn) {
    if (authz(auth)) {
      return <>{Component}</>;
    }
    // Not authorized
    return <Navigate to={urls.frontPage} state={{ from: location }} replace />;
  }

  // Not logged in
  return <Navigate to={urls.frontPage} state={{ from: location }} replace />;
};
